import React from 'react';
import { useTranslation } from 'react-i18next';
import { Headline } from '../../../headline/headline';

export const ImportTradesLastContent = () => {
    const { t } = useTranslation();

    return (
        <>
            <Headline level={3} tag={'div'} gap={'vsmall'} marginTop={'none'}>
                {t('layout.onboarding.addTrades.import.step06.headline')}
            </Headline>
            {t('layout.onboarding.addTrades.import.step06.text')}
        </>
    );
};
